import Victor from "@a-robu/victor";

const Vector = Victor

export default Vector